import { Component, inject, Input, OnInit } from '@angular/core';
import { PrintOfficeWithOfferDto } from '../print-office-selection/print-office-selection.component';
import { ModalController } from '@ionic/angular';
import { FileOfferSummary } from '../../../models/server-models/reseponse-dtos/get-offices-offers-response.dto';
import { ExpandedPrintVariation } from '../../../models/client-models/entities/expanded-print-variation';
import { PrintVariationType } from '../../../models/server-models/enums/print-variation-type';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-details-modal',
  templateUrl: './offer-details-modal.component.html',
  styleUrls: ['./offer-details-modal.component.scss'],
  standalone: false,
})
export class OfferDetailsModalComponent implements OnInit {
  modalCtrl = inject(ModalController);
  translateService = inject(TranslateService);

  @Input() selectedOffice!: PrintOfficeWithOfferDto;
  @Input() printVariation!: ExpandedPrintVariation;

  constructor() {}

  ngOnInit() {}

  async closeModal() {
    await this.modalCtrl.dismiss();
  }

  async onContinue() {
    await this.modalCtrl.dismiss({ continue: true });
  }

  getFileName(fileOfferSummary: FileOfferSummary) {
    if (this.printVariation.type != PrintVariationType.BusinessCard) {
      return fileOfferSummary.originalFileName;
    }

    return this.translateService.instant('OFFICE.OFFER.DETAILS.MODAL.BUSINESS_CARD_TITLE');
  }

  getPrintPriceWithCommission() {
    return this.selectedOffice.offerDetails.totalPrice;
  }
}
